<script lang="ts">
  export let svgStyles: string = ''
</script>

<svg viewBox="0 0 343 469" fill="none" xmlns="http://www.w3.org/2000/svg" class={svgStyles}>
  <circle cx="171.5" cy="234.5" r="234" stroke="black" />
</svg>
